import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from "react-redux"
import './styles/Sidenav.scss';
import { setModal } from '../../actions/index';
import closeImage from '../../images/icons/close_white.svg';

export default class Sidenav extends React.Component {
	constructor(props) {
		super(props);
		this.openMenu = this.openMenu.bind(this);
		this.closeMenu = this.closeMenu.bind(this);
		this.onProfileClick = this.onProfileClick.bind(this);
		this.blockClicks = this.blockClicks.bind(this);
		this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
		this.handleTouchStart = this.handleTouchStart.bind(this);
		this.handleTouchMove = this.handleTouchMove.bind(this);
		this.handleTouchEnd = this.handleTouchEnd.bind(this);
		this.startX = this.currentX = 0;
		this.goTo = this.goTo.bind(this);
	}

	componentDidMount() {
		this.baseEl = ReactDOM.findDOMNode(this.refs.base);
		this.sideNavEl = ReactDOM.findDOMNode(this.refs.sideNavEl);
	}

	componentWillUnmount() {
		//*
		this.baseEl.removeEventListener('transitionend', this.handleTransitionEnd);
		this.baseEl.removeEventListener('onTouchStart', this.handleTouchStart);
		this.baseEl.removeEventListener('onTouchMove', this.handleTouchMove);
		this.baseEl.removeEventListener('onTouchEnd', this.handleTouchEnd);
		//    */
	}

	blockClicks(evt) {
		evt.stopPropagation();
	}

	goTo(path){
		this.props.goTo(path);
		this.closeMenu()
	}

	handleTouchStart(evt) {

		this.baseX = 0;
		if (!this.baseEl.classList.contains('side-nav--visible')) {
			this.baseX = -(300);
		}

		this.startX = evt.touches[0].pageX;
		this.baseEl.classList.add('side-nav--clickable');
		this.baseEl.classList.remove('side-nav--animatable');
		this.currentX = this.startX;
	}

	handleTouchMove(evt) {

		this.currentX = evt.touches[0].pageX;
		const translateX = Math.min(0, this.baseX + this.currentX - this.startX);
		//const opacity = Math.max(0, (this.baseX + this.currentX) / this.baseX);
		//console.log('opacity', opacity, (this.baseX + this.currentX) / this.baseX);
		if (translateX < 0) {
			evt.preventDefault();
		}
		this.sideNavEl.style.transform = `translateX(${translateX}px)`;
	}

	handleTouchEnd(evt) {
		const translateX = Math.min(0, this.currentX - this.startX);
		if (translateX < 0) {
			this.closeMenu();
		} else {
			this.sideNavEl.style.transform = 'initial';
			this.openMenu();
		}
	}

	handleTransitionEnd(evt) {
		this.baseEl.classList.remove('side-nav--animatable');
		this.sideNavEl.removeEventListener('transitionend', this.handleTransitionEnd);
	}

	openMenu() {
		this.refs.hideButton.classList.add('on');
		this.baseEl.classList.add('side-nav--animatable', 'side-nav--visible');
		this.sideNavEl.addEventListener('transitionend', this.handleTransitionEnd);
		this.props.callback(true)

	}

	closeMenu() {
		this.sideNavEl.style.transform = '';
		this.sideNavEl.addEventListener('transitionend', this.handleTransitionEnd);
		this.baseEl.classList.add('side-nav--animatable');
		this.baseEl.classList.remove('side-nav--visible');
		this.refs.hideButton.classList.remove('on');
		this.props.callback(false)

	}

	onProfileClick() {
		this.props.dispatch(setModal('UserEmailConfirm', null, {}, true, 'fullscreen'));
		this.closeMenu();
	}

	render() {
		const { children, onLogout, Content, className } = this.props;
		return (
			<aside ref="base" className={`js-side-nav side-nav ${className}`} onClick={this.closeMenu}>
				<div ref="sideNavEl" className="js-side-nav-container side-nav__container"
					onTouchStart={this.handleTouchStart}
					onTouchMove={this.handleTouchMove}
					onTouchEnd={this.handleTouchEnd}>

					<nav onClick={this.blockClicks} className="side-nav__actual">
						<button ref="hideButton" onClick={this.closeMenu} className="js-menu-hide side-nav__hide close">
							<img src={closeImage} alt="Close" />
						</button>

						{Content && <Content closeMenu={this.closeMenu} onLogout={onLogout} onProfileClick={this.onProfileClick} {...this.props} />}
						{children}
					</nav>
				</div>
			</aside>)
	}
}



// WEBPACK FOOTER //
// ./src/components/sidenav/Sidenav.jsx